// d01, d02 등 라이더 출석표 리스폰스의 key값 순회하기 위함
export const workerMonthAttendanceDayList = new Array(31).fill(0)
    .map((_, index) => `d${(index + 1).toString().padStart(2, '0')}`);
